import { ApiBind, CommonSearchParam } from './common-search-param.model';

export class SDKVersionGroupSearchParam extends CommonSearchParam {

  constructor(
    name?: string,
  ) {
    super();
    this.name = name;
  }

  @ApiBind({ column: 'name' })
  name: string;
}
